import { render, staticRenderFns } from "./HtmlBlock.vue?vue&type=template&id=56744e68&scoped=true"
import script from "./HtmlBlock.vue?vue&type=script&lang=ts"
export * from "./HtmlBlock.vue?vue&type=script&lang=ts"
import style0 from "./HtmlBlock.vue?vue&type=style&index=0&id=56744e68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56744e68",
  null
  
)

export default component.exports